import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Container,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Person, Mail, Lock, Visibility, VisibilityOff, CorporateFare } from '@mui/icons-material';
// import logo from '../../images/logo_veribase.png';
import logo from '../../images/logo_fiducia_full.png';
import AuthTabs from '../../components/Auth/AuthTabs';

import { useNavigator } from '../../hooks/useNavigator';
import { useAuth } from '../../hooks/useAuth';
import { client } from "../../services/api";
import { toast } from 'react-hot-toast';
import { toastConfig, successToastConfig, dangerToastConfig } from '../../utils/data';
import { validateEmail, validateText, validatePassword } from '../../utils/validations';
import { generateRandomId } from '../../utils/tools';

const Signup = () => {
  const navigator = useNavigator();
  const { screens, pathname, searchParams } = useNavigator();
  const [inviteOrg, setInviteOrg] = useState(null);
  const { signUp, loading, error } = useAuth();

  const navigate = useNavigate();
  const { theme } = useTheme();
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    orgname: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  
  
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [validCode, setValidCode] = useState(false);
  const [formValidations, setFormValidations] = useState({
    firstname: { isValid: true, message: 'Invalid Characters', validation: validateText },
    lastname: { isValid: true, message: 'Invalid Characters', validation: validateText },
    orgname: { isValid: true, message: 'Invalid Characters', validation: validateText },
    email: { isValid: true, message: 'Invalid Email', validation: validateEmail },
    password: { isValid: true, message: 'Invalid Password', validation: validatePassword },
    confirmPassword: { isValid: true, message: 'Please make sure passwords match', validation: null },
  });

  // Get current params at component level
  const currentParams = Object.fromEntries([...searchParams]);
  const hasInviteCode = currentParams.invitecode !== undefined;
  const showSignupForm = !hasInviteCode || validCode;

  const textFieldStyles = {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
      },
      '&:hover fieldset': {
        borderColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)',
      },
      '&.Mui-focused fieldset': {
        borderColor: theme === 'dark' ? '#87cefa' : '#2791d2',
      },
      '&.Mui-focused .MuiInputLabel-root': {
        color: theme === 'dark' ? '#87cefa' : '#2791d2',
      },
      '& input:-webkit-autofill': {
        WebkitBoxShadow: theme === 'dark' 
          ? '0 0 0 100px rgba(30, 30, 30, 0.95) inset'
          : '0 0 0 100px rgba(255, 255, 255, 0.95) inset',
        WebkitTextFillColor: theme === 'dark' ? '#fff' : '#000',
        transition: 'background-color 5000s ease-in-out 0s',
      },
      '&.Mui-disabled': {
        opacity: 0.5,
        // '& .MuiOutlinedInput-notchedOutline': {
        //   borderColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
        // },
        '& .MuiInputLabel-root': {
          color: theme === 'dark' ? 'rgba(255, 255, 255, 0.38)' : 'rgba(0, 0, 0, 0.38)',
        },
        '& .MuiInputAdornment-root .MuiSvgIcon-root': {
          color: theme === 'dark' ? 'rgba(255, 255, 255, 0.38)' : 'rgba(0, 0, 0, 0.38)',
        },
      },
    },
    '& .MuiInputLabel-root': {
      color: theme === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)',
    },
  };

  useEffect(() => {
    setTimeout(async () => {
        if(currentParams.invitecode !== undefined && !validCode){
          let c = currentParams.invitecode;
                    if(c == "init"){
            setValidCode(true);
            setFormData({ ...formData, code: c });
            return;
          }else{
            let codeLookup = await client.getInviteCodeLookup(c);
                        if(codeLookup.data){
              setInviteOrg(codeLookup.data.organization);
              toast('Invite Code Valid', successToastConfig);
              setValidCode(true);
              setFormData({ ...formData, email: codeLookup.data.email, code: codeLookup.data.code, accountId: codeLookup.data.accountId, id: codeLookup.data._id });
            }else{
              toast('Invalid Invite Code', dangerToastConfig);
            }
                                  }
          

        }else{
          // toast('No Invite Code', dangerToastConfig);
        }
    },20)
  },[validCode])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
        
    if(formValidations[name].validation){
     
      const validation = formValidations[name].validation(value);
 
      let fv = {
        ...formValidations[name],
        isValid: !validation ? true : false,
      }
      setFormValidations(prev => ({
        ...prev,
        [`${name}`]: fv
      }));
    }
    if(name === 'confirmPassword'){
            if(formData.password !== value){

        setFormValidations(prev => ({
          ...prev,
          confirmPassword: { isValid: false, message: 'Passwords do not match', validation: null }
        }));
      }else{
        setFormValidations(prev => ({
          ...prev,
          confirmPassword: { isValid: true, message: 'Passwords do not match', validation: null }
        }));
      }
    }
    // Run email validation when email field changes
    // if (name === 'email') {
    //   const emailValidation = validateEmail(value);
    //   let fv = {
    //     isValid: !emailValidation ? true : false,
    //     message: emailValidation ? 'Invalid Email' : ''
    //   }
    //   setFormValidations(prev => ({
    //     ...prev,
    //     email: fv
    //   }));
    // }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let error = false;
    for(var key in formValidations){
      if(!formValidations[key].isValid){
        toast(`${formValidations[key].message}`, dangerToastConfig);
        error = true;
      }
    }

    if(error){
      return;
    }

    let sudata = {
      email: event.target.email.value,
      password: event.target.password.value,
      firstname: event.target.firstname.value,
      lastname: event.target.lastname.value,
      ic: validCode ? formData.code : null,
      accountId: validCode ? formData.accountId : null,
      id: validCode ? formData.id : generateRandomId(),
    }

        
    const success = await signUp(sudata);

    if (success) {
      navigate('/');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Card
          elevation={0}
          sx={{
            width: '100%',
            maxHeight: '90vh',
            overflow: 'auto',
            background: theme === 'dark' 
              ? 'rgba(30, 30, 30, 0.73)'
              : 'rgba(255, 255, 255, 0.73)',
            backdropFilter: 'blur(10px)',
            border: '1px solid',
            borderColor: theme === 'dark'
              ? 'rgba(255, 255, 255, 0.1)'
              : 'rgba(255, 255, 255, 0.2)',
            borderRadius: 2,
            '& .MuiTypography-root': {
              fontFamily: '"Space Grotesk", sans-serif',
            },
            '& .MuiInputLabel-root': {
              fontFamily: '"Space Grotesk", sans-serif',
            },
            '& .MuiInputBase-input': {
              fontFamily: '"Space Grotesk", sans-serif',
            },
            '& .MuiButton-root': {
              fontFamily: '"Space Grotesk", sans-serif',
              fontWeight: 500,
            },
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              background: theme === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
              borderRadius: '4px',
              '&:hover': {
                background: theme === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
              },
            },
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <AuthTabs />

           
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mb: 2,
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Veritas"
                sx={{ width: 155, mb: 2 }}
              />

              {/* <Typography variant="body2" color="text.secondary">
                Agree to Terms of Service and Privacy Policy.{' '}
              </Typography> */}
              {/* <Typography
                variant="h6"
                component="h6"
                sx={{
                  color: 'text.primary',
                  fontWeight: 600,
                }}
              >
                Create Account
              </Typography> */}
            </Box>


            

            {validCode ? (
              <>
                { inviteOrg && inviteOrg.name.length > 0 ? (
                    <p style={{lineHeight: 1.5}}>Welcome to <b>Fiducia 360</b>.<br/>You have been invited by <b>{inviteOrg.name}</b> to join their team.</p>
              
              
                ):(
                  <p style={{lineHeight: 1.5}}>Welcome to <b>Fiducia 360</b>.<br/>You have been invited to create an account and organization.</p>
              
              
                )}
              </>
            ):null}

          

            { !showSignupForm ? (
              <>
                <Box sx={{ textAlign: 'center', marginBottom: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    A link with a valid invite code is necessary for signup.{' '}
                  </Typography>
                  
                </Box>
              
              </>
            ):(

              <Box component="form" onSubmit={handleSubmit} sx={{ mb: 3 }}>
                <TextField
                  fullWidth
                  label="First Name"
                  name="firstname"
                  value={formData.firstname}
                  onChange={handleInputChange}
                  margin="dense"
                  size="small"
                  required
                  disabled={false}
                  error={!formValidations.firstname.isValid}
                  helperText={!formValidations.firstname.isValid ? formValidations.firstname.message : ''}
                  // placeholder='First Name'
                  sx={textFieldStyles}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment 
                        position="start"
                        sx={{
                          backgroundColor: 'transparent',
                          '& .MuiInputAdornment-root': {
                            backgroundColor: 'transparent',
                          }
                        }}
                      >
                        <Person sx={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)' }} />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  fullWidth
                  label="Last Name"
                  name="lastname"
                  value={formData.lastname}
                  onChange={handleInputChange}
                  margin="dense"
                  size="small"
                  required
                  disabled={false}
                  error={!formValidations.lastname.isValid}
                  helperText={!formValidations.lastname.isValid ? formValidations.lastname.message : ''}
                  sx={textFieldStyles}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment 
                        position="start"
                        sx={{
                          backgroundColor: 'transparent',
                          '& .MuiInputAdornment-root': {
                            backgroundColor: 'transparent',
                          }
                        }}
                      >
                        <Person sx={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)' }} />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  margin="dense"
                  size="small"
                  required
                  disabled={hasInviteCode}
                  error={!formValidations.email.isValid}
                  helperText={!formValidations.email.isValid ? formValidations.email.message : ''}
                  sx={textFieldStyles}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment 
                        position="start"
                        sx={{
                          backgroundColor: 'transparent',
                          '& .MuiInputAdornment-root': {
                            backgroundColor: 'transparent',
                          }
                        }}
                      >
                        <Mail sx={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)' }} />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  fullWidth
                  label="Password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  value={formData.password}
                  onChange={handleInputChange}
                  margin="dense"
                  size="small"
                  required
                  disabled={false}
                  error={!formValidations.password.isValid}
                  helperText={!formValidations.password.isValid ? formValidations.password.message : ''}
                  sx={textFieldStyles}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment 
                        position="start"
                        sx={{
                          backgroundColor: 'transparent',
                          '& .MuiInputAdornment-root': {
                            backgroundColor: 'transparent',
                          }
                        }}
                      >
                        <Lock sx={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment 
                        position="end"
                        sx={{
                          backgroundColor: 'transparent',
                          '& .MuiInputAdornment-root': {
                            backgroundColor: 'transparent',
                          }
                        }}
                      >
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? 
                            <VisibilityOff sx={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)' }} /> : 
                            <Visibility sx={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)' }} />
                          }
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  fullWidth
                  label="Confirm Password"
                  name="confirmPassword"
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  margin="dense"
                  size="small"
                  required
                  disabled={false}
                  error={!formValidations.confirmPassword.isValid}
                  helperText={!formValidations.confirmPassword.isValid ? formValidations.confirmPassword.message : ''}
                  sx={textFieldStyles}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment 
                        position="start"
                        sx={{
                          backgroundColor: 'transparent',
                          '& .MuiInputAdornment-root': {
                            backgroundColor: 'transparent',
                          }
                        }}
                      >
                        <Lock sx={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment 
                        position="end"
                        sx={{
                          backgroundColor: 'transparent',
                          '& .MuiInputAdornment-root': {
                            backgroundColor: 'transparent',
                          }
                        }}
                      >
                        <IconButton
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          edge="end"
                        >
                          {showConfirmPassword ? 
                            <VisibilityOff sx={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)' }} /> : 
                            <Visibility sx={{ color: theme === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.6)' }} />
                          }
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  size="large"
                  disabled={false}
                  sx={{
                    mt: 3,
                    mb: 2,
                    py: 1.5,
                    textTransform: 'none',
                    background: theme === 'dark' ? '#87cefa' : '#2791d2',
                    '&:hover': {
                      background: theme === 'dark' ? '#5f9eb3' : '#1a6b9e',
                    },
                  }}
                >
                  Create Account
                </Button>
              </Box>


            )}

            

            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary">
                Already have an account?{' '}
                <Link
                  to="/login"
                  style={{
                    color: theme === 'dark' ? '#87cefa' : '#2791d2',
                    textDecoration: 'none',
                    fontWeight: 500,
                  }}
                >
                  Sign in
                </Link>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Signup;
